module.exports = require('./ConsumerDiscountRenewalApplicationView');
